module.exports = require('./ConsumerDiscountRenewalApplicationView');
